import React from "react";
import { Path } from "../Path";
import { PublicGameFromRoute } from "./PublicGameView";
import { PublicRoute } from "../core/AppWithSideMenu";
import { PublicDesignerFromRoute } from "./PublicDesigner";
import { PublicEventFromRoute } from "./PublicEventView";
import { FeedbackFormFromRoute, PlayTestFeedbackFromRoute } from "./FeedbackForm";
import { ThankYouFromRoute } from "./ThankYouPage";
import { PublicEventListAndDetail } from "./PublicEventListAndDetail";
export const routes = [
  {
    path: Path.public().designer(":username").pathname,
    element: (
      <PublicRoute>
        <PublicDesignerFromRoute />
      </PublicRoute>
    ),
  },
  {
    path: Path.public().game(":username", ":slug").pathname,
    element: (
      <PublicRoute>
        <PublicGameFromRoute />
      </PublicRoute>
    ),
  },
  {
    path: Path.public().pnp(":username", ":slug", ":pnp").pathname,
    element: (
      <PublicRoute>
        <PublicGameFromRoute />
      </PublicRoute>
    ),
  },
  {
    path: Path.public().feedback(":username", ":slug").pathname,
    element: (
      <PublicRoute>
        <FeedbackFormFromRoute />
      </PublicRoute>
    ),
  },
  {
    path: Path.public().playTestFeedback(":username", ":slug", ":playTestId").pathname,
    element: (
      <PublicRoute>
        <PlayTestFeedbackFromRoute />
      </PublicRoute>
    ),
  },
  {
    path: Path.public().feedbackThankYou(":username", ":slug").pathname,
    element: (
      <PublicRoute>
        <ThankYouFromRoute />
      </PublicRoute>
    ),
  },
  {
    path: Path.public().events().pathname,
    element: (
      <PublicRoute>
        <PublicEventListAndDetail />
      </PublicRoute>
    ),
    handle: {
      prefer: "left",
    },
  },
  {
    path: Path.public().event(":slug").pathname,
    element: (
      <PublicRoute>
        <PublicEventFromRoute />
      </PublicRoute>
    ),
    handle: {
      prefer: "right",
    },
  },
];
